/**
 * @deprecated We should not directly mutate the graphql cache. We should call the `saveOrUpdateAttribute` endpoint on the userattributes service.
 */
export const updateCache = `mutation UpdateCache($data: String, $key: String, $type: String) {
  updateCache(data: $data, key: $key, type: $type) {
    result
  }
}
`
